module.exports = __webpack_public_path__ + "static/media/0x.b1498eae.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/0x.svg
// module id = 1141
// module chunks = 0